export default async function loaderStop({ context, nextMiddleware }) {
  try {
    console.log('loaderStop');
    context.store.loaderStore.setLoader();
  } catch (e) {
    console.error(e);
    return context.next(false);
  }
  return nextMiddleware();
}
